import { all, call } from 'redux-saga/effects';
import homeSaga from '../screens/Home/saga';

// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        call(homeSaga),
        // all of the app related sagas will go here
    ]);
}
